(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.getElementById('header');
    var menu = document.getElementById('siteHeaderMenu');
    var toggle = document.getElementById('menuToggle');

    if (!header || !menu || !toggle) return;

    var SCROLL_THRESHOLD = 80;
    var mqlMobile = window.matchMedia('(max-width: 767.98px)');
    var isCollapsed = false;
    var ticking = false;

    // ─── Scroll collapse ───
    function onScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var shouldCollapse = scrollY > SCROLL_THRESHOLD;

        if (shouldCollapse !== isCollapsed) {
          isCollapsed = shouldCollapse;
          header.classList.toggle('is-collapsed', isCollapsed);
        }

        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ─── Mobile menu ───
    function isOpen() {
      return header.classList.contains('is-menu-open');
    }

    function lockScroll(lock) {
      document.documentElement.classList.toggle('menu-scroll-lock', lock);
      document.body.classList.toggle('menu-scroll-lock', lock);
    }

    function openMenu() {
      header.classList.add('is-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Fechar menu de navegação');
      lockScroll(true);

      var firstLink = menu.querySelector('a');
      if (firstLink) {
        setTimeout(function () {
          firstLink.focus({ preventScroll: true });
        }, 100);
      }
    }

    function closeMenu() {
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir menu de navegação');
      lockScroll(false);
      toggle.focus();
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      isOpen() ? closeMenu() : openMenu();
    });

    // Escape to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        closeMenu();
      }
    });

    // Close mobile menu on link click
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a') && mqlMobile.matches) {
        closeMenu();
      }
    });

    // Close mobile menu when resizing to desktop
    mqlMobile.addEventListener('change', function (e) {
      if (!e.matches && isOpen()) {
        closeMenu();
      }
    });
  });
})();
